<template>
  <div>
    <slot name="viewAssociatedBusiness" />
    <template v-if="!!upElementBlock">
      <slot v-for="elementName in upElementBlock.elementNames" :name="elementName" />
    </template>
    <div v-if="middleElementBlocks.length > 0" class="section" style="display:flex;flex-direction: row;">
      <template v-for="(item, index) in middleElementBlocks">
        <div v-if="item.name === 'DangerousGoodsInformation'" :key="'DangerousGoodsInformation-' + index" style="width: 525px">
          <span class="title">{{ item.title }}</span>
          <el-form
            label-width="190px"
            label-position="left"
            style="display:flex;flex-direction:column;margin-left: 10px;"
          >
            <template v-for="elementName in item.elementNames">
              <slot :name="elementName" />
            </template>
          </el-form>
        </div>
        <div v-else :key="'DangerousGoodsInformation2-' + index" style="width: 345px;margin-left:20px;">
          <span class="title">{{ item.title }}</span>
          <el-form
            label-width="120px"
            label-position="left"
            style="display:flex;flex-direction:column;margin-left: 10px;"
          >
            <template v-for="elementName in item.elementNames">
              <slot :name="elementName" />
            </template>
          </el-form>
        </div>
      </template>
    </div>
    <template v-if="!!downElementBlock">
      <slot v-for="elementName in downElementBlock.elementNames" :name="elementName" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'TabSpecialGoodsUICustomLayout',
  props: {
    elementBlocks: { type: Array, required: true }
  },
  computed: {
    upElementBlock() {
      return this.elementBlocks.find(p => p.position === 1 && !p.hide)
    },
    middleElementBlocks() {
      return this.elementBlocks.filter(p => p.position === 2 && !p.hide)
    },
    downElementBlock() {
      return this.elementBlocks.find(p => p.position === 3 && !p.hide)
    }
  }
}
</script>
